import { useContext } from "react";

import { GlobalConfirmContext } from "Contexts/GlobalConfirmContext";

const UseGlobalConfirm = () => {
  const { confirmProps, addGlobalConfirm, removeGlobalConfirm } =
    useContext(GlobalConfirmContext);
  return { confirmProps, addGlobalConfirm, removeGlobalConfirm };
};

export default UseGlobalConfirm;
